import translate from 'loankeeper-common/helpers/language'

export const translateLKMessage = (key: string): string => translate('LKMESSAGE', key)

export default (key: string): string => translate('frm_Main', key)
